import { render, staticRenderFns } from "./AdminUsuariosFormulario.vue?vue&type=template&id=181793aa&"
import script from "./AdminUsuariosFormulario.vue?vue&type=script&lang=ts&"
export * from "./AdminUsuariosFormulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports